import { Component } from '@angular/core';
import { NamedRoutesService } from "ng-named-routes";
import { AppRoutingModule } from "../app-routing.module";

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  menuOpen = false;
  mainHeaders = mainHeaders;
  routeName: string;

  constructor(private namedRoutesService: NamedRoutesService, private appRoutingModule: AppRoutingModule) {
    this.fillRouteInfo(this.mainHeaders)
  }

  fillRouteInfo(routes) {
    routes.forEach((route) => {
      if(route.name) {
        let result = this.appRoutingModule.getRoute(route.name);
        route.title = result.title;
        route.path = '/' + result.path;

        if(route.children) {
          this.fillRouteInfo(route.children);
        }
      }
    });
  }

}

export const mainHeaders = [
  {
    name: 'deployments',
    dropdownOpen: false,
    children: [
      { name: 'deploymentList' },
      { name: 'mission' },
      { name: 'monitoring' },
    ]
  },
  { name: 'equipment' },
  {
    name: 'data',
    dropdownOpen: false,
    children: [
      { name: 'download' },
      { name: 'plot' },
      { title: 'Catalogue', path: 'https://data.ceotr.ca/erddap/search/index.html?searchFor=glider' }
    ]
  },
  {
    name: 'about',
    dropdownOpen: false,
    children: [
      { name: 'us' },
      { name: 'contact' },
      { name: 'partners' }
    ]
  },
];